import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { Truck, Loader2, ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setError(apiErr(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC] p-6">
      <div className="w-full max-w-sm animate-slide-up">
        <div className="mb-8 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#FF6500] text-white"><Truck size={24} /></div>
          <span className="font-head text-xl font-extrabold text-[#0B192C]">GS Pacific ePOD</span>
        </div>
        {sent ? (
          <div className="rounded-xl border border-slate-200 bg-white p-6 text-center">
            <MailCheck className="mx-auto text-emerald-600" size={40} />
            <h2 className="mt-3 font-head text-xl font-bold text-[#0B192C]">Check your inbox</h2>
            <p className="mt-2 text-sm text-slate-500">If that email is registered, a reset link has been sent. It expires in 1 hour.</p>
            <Link to="/login" className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#1E3E62] hover:underline">
              <ArrowLeft size={16} /> Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="rounded-xl border border-slate-200 bg-white p-6">
            <h2 className="font-head text-xl font-bold text-[#0B192C]">Reset password</h2>
            <p className="mt-1 text-sm text-slate-500">Enter your email and we'll send a reset link.</p>
            <input
              data-testid="forgot-email-input"
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-4 w-full rounded-xl border border-slate-300 px-4 py-3 text-sm outline-none focus:border-[#0B192C]"
              placeholder="you@gspacific.com.au"
            />
            {error && <div className="mt-3 rounded-lg bg-rose-50 px-3 py-2 text-sm text-rose-700">{error}</div>}
            <button data-testid="forgot-submit-button" disabled={loading} className="mt-4 flex w-full items-center justify-center gap-2 rounded-xl bg-[#0B192C] py-3 font-bold text-white tap-shrink disabled:opacity-60">
              {loading ? <Loader2 className="animate-spin" size={18} /> : "Send reset link"}
            </button>
            <Link to="/login" className="mt-4 flex items-center justify-center gap-1.5 text-sm font-semibold text-[#1E3E62] hover:underline">
              <ArrowLeft size={16} /> Back to sign in
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
